import MobileDetect from 'mobile-detect';
import interfaceBridge from './interfaceBridge';

type NativeFeatureT = 'videoUpload' | 'theme';

type RequirementT = {
  ios: number;
  android: number;
  testEnv: number;
};

const nativeFeatureAndRequirementMap: Map<NativeFeatureT, RequirementT> =
  new Map([
    [
      'videoUpload',
      {
        ios: 9, // 1.4.0
        android: 6, // 1.4.0
        testEnv: 1,
      },
    ],
    [
      'theme',
      {
        // currently shipped native builds are fixed dark:
        // iOS build 21 / Android build 26
        ios: 22,
        android: 27,
        testEnv: 1,
      },
    ],
  ]);

export class NativeFeatureChecker {
  static isSupported(featureName: NativeFeatureT): boolean {
    const requirement = nativeFeatureAndRequirementMap.get(featureName);
    if (!requirement) return false;

    const appBuildNumber = interfaceBridge.getAppBuildNumber();
    if (!appBuildNumber) return false;

    const type = new MobileDetect(window.navigator.userAgent);
    if (type.is('iOS')) {
      return appBuildNumber >= requirement.ios;
    }

    if (type.is('AndroidOS')) {
      return appBuildNumber >= requirement.android;
    }

    if (interfaceBridge.isTestEnvironment()) {
      return appBuildNumber >= requirement.testEnv;
    }

    return false;
  }

  static check(featureName: NativeFeatureT): true | string {
    const needTopUpdate = '이 기능을 사용하기 위해서는 앱을 업데이트 해주세요.';
    const notSupported = '지원하지 않는 기능입니다.';

    const requirement = nativeFeatureAndRequirementMap.get(featureName);

    if (!requirement) return notSupported;

    const appBuildNumber = interfaceBridge.getAppBuildNumber();

    console.log('appBuildNumber=', appBuildNumber);

    if (!appBuildNumber) return needTopUpdate;

    const type = new MobileDetect(window.navigator.userAgent);
    if (type.is('iOS')) {
      if (!NativeFeatureChecker.isSupported(featureName)) return needTopUpdate;
      return true;
    } else if (type.is('AndroidOS')) {
      if (!NativeFeatureChecker.isSupported(featureName)) return needTopUpdate;
      return true;
    } else if (interfaceBridge.isTestEnvironment()) {
      // test interface
      if (!NativeFeatureChecker.isSupported(featureName)) return needTopUpdate;
      return true;
    } else {
      // ios, and 아님
      return notSupported;
    }
  }
}
